<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M5,7C5,7,11,7,11,7C11.55,7,12,6.55,12,6C12,5.720000000000001,11.89,5.470000000000001,11.71,5.29C11.71,5.29,8.71,2.29,8.71,2.29C8.530000000000001,2.11,8.280000000000001,2,8,2C7.720000000000001,2,7.470000000000001,2.11,7.29,2.29C7.29,2.29,4.29,5.29,4.29,5.29C4.11,5.470000000000001,4,5.720000000000001,4,6C4,6.55,4.45,7,5,7C5,7,5,7,5,7ZM11,9C11,9,5,9,5,9C4.45,9,4,9.45,4,10C4,10.28,4.11,10.53,4.29,10.71C4.29,10.71,7.29,13.71,7.29,13.71C7.470000000000001,13.89,7.720000000000001,14,8,14C8.280000000000001,14,8.530000000000001,13.89,8.71,13.71C8.71,13.71,11.71,10.71,11.71,10.71C11.89,10.53,12,10.28,12,10C12,9.45,11.55,9,11,9C11,9,11,9,11,9Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'DoubleCaretVertical',
} as DefineComponent
</script>
